import { Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import CollectionPinUnpin from '@components/CollectionPinUnpin';
import DeleteModal from '@components/DeleteModal';
import { toastError, toastSuccess } from '@components/Toast';

import { removeItemFromFilterResponse } from '@store/actions/FilterAction';

import ApiClient from '@lib/apiClient';

import { getCollectionTimeCount, getShortName, replaceUnderLine } from '@utils/Util';

import CollectionAddAndEdit from '@/components/CollectionAddAndEdit';

const CollectionItem = ({ collection, index, imageType, collectionType, pathName, fetchCollectionList }) => {
	const [openConfirmationModal, setConfirmationModal] = useState(false);
	const [queryParam, setQueryParam] = useState('');
	const [selectedCollection, setSelectedCollection] = useState(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const removeCollection = () => {
		let body = {
			id: collection.id
		};
		ApiClient.DELETE_WITH_BODY('deleteCollection', body)
			.then(({ data }) => {
				dispatch(removeItemFromFilterResponse(collection.id));
				setConfirmationModal(false);
				toastSuccess(data.message);
			})
			.catch(({ response }) => {
				toastError(response.data.message);
			});
	};

	const TABS = ['Development', 'Complete', 'Sold'];

	const routeToCollectionView = (event) => {
		if (!(event.metaKey || event.ctrlKey || event.button === 2)) {
			// Prevent default navigation for normal left-clicks to handle custom logic
			event.preventDefault();

			const queryParams =
				pathName === '/nitex-studio'
					? 'Published'
					: TABS.includes(collectionType)
						? collectionType
						: '';
			setQueryParam(queryParams);
			sessionStorage.setItem('scrollPosition', window.pageYOffset);
			navigate(`/collections/view/${collection.id}?status=${queryParams}`);
		}
	};

	let docs =
		imageType === 'PRODUCT_IAMGE'
			? collection?.moodboardProductImageList
			: collection.documentPathList
				? collection.documentPathList
				: [];

	const getStatus = {
		BUYER_REQUEST: 'orange-1',
		BUYER_DESIGN: 'blue-1',
		SHARED_WITH_BUYER: 'white-1',
		PRESENTATION: 'white-1',
		BUYER_SELECTION: 'pink-1 buyers-selection'
	};

	return (
		<>
			<div className="single-collection-item" key={`collection_item_${index}`}>
				<Link
					to={`/collections/view/${collection.id}?status=${queryParam}`}
					onClick={routeToCollectionView}
				>
					<div className="product-img-container">
						<div className="prev-img">
							{docs.length ? (
								<img src={docs[0]} alt="" />
							) : (
								<img src={`${process.env.PUBLIC_URL}/images/default_product.svg`} alt="" />
							)}
						</div>
						<div className="prev-img-thumb">
							{docs.length > 1 ? (
								<div className="single-first">
									<img src={docs[1]} alt="" />
								</div>
							) : (
								<div className="single-first">
									<img
										src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
										alt=""
									/>
								</div>
							)}
							{docs.length > 2 ? (
								<div className="single-second">
									<img src={docs[2]} alt="" />
								</div>
							) : (
								<div className="single-second">
									<img
										src={`${process.env.PUBLIC_URL}/images/default_product.svg`}
										alt=""
									/>
								</div>
							)}
						</div>
						{collection?.isNew && <span className="new-tag status">NEW</span>}
						<div className="collection-status d-flex justify-content-between align-items-center">
							{collection?.tagCategory && collection?.tagCategory !== 'BUYER_SELECTION' && (
								<span className={`status ${getStatus[collection?.tagCategory]}`}>
									{replaceUnderLine(collection?.tagCategory)}
								</span>
							)}

							{/* {collection?.isBuyerSelection && (
								<span className={`status ${getStatus[collection?.isBuyerSelection]}`}>
									{replaceUnderLine(collection?.isBuyerSelection)}
								</span>
							)} */}
							{collection?.creationPurposeTagResponse && (
								<span className="status brown-2">
									{collection?.creationPurposeTagResponse?.text}
								</span>
							)}
						</div>
						{collection?.hasUnseenMention && (
							<div className="comment-unread">
								<img
									src={`${process.env.PUBLIC_URL}/icons/comment-not-read.svg`}
									alt="comment"
								/>
							</div>
						)}
					</div>
				</Link>
				<CollectionPinUnpin collection={collection} />
				<div>
					<Link
						to={`/collections/view/${collection.id}?status=${queryParam}`}
						onClick={routeToCollectionView}
					>
						<div className="details">
							<Tooltip
								title={<span className="regular-14">{collection?.name}</span>}
								placement="top"
								arrow
							>
								<p className="collection-title hover-underline regular-12 mb-0 gray_dark_01 weight-500">
									{getShortName(collection?.name, 29)}&nbsp; (
									<span>
										<span className="green">{collection?.numOfCompletedDesign}/</span>
										{collection?.numOfDesign}
									</span>
									)
								</p>
							</Tooltip>
							<ul className="common-list-component mt-1">
								<li className="text-uppercase">
									{collectionType === 'BUYER_REQUEST'
										? collection?.createdBy
										: collection?.ownerName}
								</li>
								<li className="text-uppercase">{collection?.brand}</li>
								{collection?.season && (
									<li className="text-uppercase">{collection?.season.replace('_', '')}</li>
								)}

								<li className="text-uppercase">
									{getCollectionTimeCount(collection?.dateCreated)}
								</li>
							</ul>
						</div>
					</Link>
				</div>
				<div className="option">
					<div className="dropdown">
						<button
							className="btn btn-default dropdown-toggle"
							type="button"
							id="menu1"
							data-toggle="dropdown"
							aria-expanded="false"
						>
							<img src={process.env.PUBLIC_URL + '/icons/more_icon.svg'} alt="more" />
						</button>
						<ul className="dropdown-menu dropdown-menu-right shadow-lg">
							<li className="px-4 pb-3">
								<span
									className="text-nowrap"
									onClick={() => setSelectedCollection(collection)}
								>
									Edit collection details
								</span>
							</li>
							<li className="px-4 pb-3">
								<span className="red" onClick={() => setConfirmationModal(true)}>
									Delete
								</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			{openConfirmationModal && (
				<DeleteModal onRemove={removeCollection} onClose={() => setConfirmationModal(false)} />
			)}
			{selectedCollection?.id === collection?.id && (
				<CollectionAddAndEdit
					onSubmiCollection={() => {
						setSelectedCollection(null);
						fetchCollectionList();
					}}
					collectionId={selectedCollection?.id}
					onClose={() => setSelectedCollection(null)}
					type="EDIT"
				/>
			)}
		</>
	);
};

export default CollectionItem;
